import { appStore } from "../state/store";
import { ProgressBar } from "./ProgressBar";
export class BfiProfile {
    constructor(app) {
        this.app = app;
        this.traits = [
            { id: 'openness', label: 'Openness (Imaginative, Curious)' },
            { id: 'conscientiousness', label: 'Conscientiousness (Organized, Disciplined)' },
            { id: 'extraversion', label: 'Extraversion (Sociable, Energetic)' },
            { id: 'agreeableness', label: 'Agreeableness (Cooperative, Trusting)' },
            { id: 'neuroticism', label: 'Neuroticism (Calm, Secure vs. Anxious)' },
        ];
        this.progressBar = new ProgressBar(7, 4);
    }
    render() {
        // MODIFICATION: Read the BFI profile from the store to set initial slider values.
        const bfiProfile = appStore.getState().user.profile.bfiProfile;
        const sliderGroups = this.traits.map(({ id, label }) => {
            var _a;
            return `
            <div class="form-group">
                <label for="${id}">${label}</label>
                <input type="range" id="${id}" name="${id}" min="1" max="100" value="${(_a = bfiProfile[id]) !== null && _a !== void 0 ? _a : 50}">
            </div>
        `;
        }).join('');
        return `
            <div class="card">
                ${this.progressBar.render()}
                <h2>Step 3: Calibrate Your Profile</h2>
                <p class="narrative-transition"><em>You've mapped your past success. Now let's build a profile to author your future.</em></p>
                <p>This data is key to unlocking truly personalized scheduling.</p>
                <form id="bfi-form">
                    ${sliderGroups}
                    <div class="button-container">
                        <button type="submit" class="button-primary">Next</button>
                    </div>
                </form>
            </div>
        `;
    }
    attachEventListeners() {
        var _a;
        (_a = document.getElementById('bfi-form')) === null || _a === void 0 ? void 0 : _a.addEventListener('submit', (e) => {
            e.preventDefault();
            const profile = {};
            this.traits.forEach(({ id }) => {
                const input = document.getElementById(id);
                if (input) {
                    profile[id] = parseInt(input.value, 10);
                }
            });
            appStore.updateBfiProfile(profile);
            this.app.nextStep();
        });
    }
}
